import clsx from 'clsx'
import { Combobox, InputBase, InputBaseProps, useCombobox } from 'summon-ui/mantine'
import ETHIcon from '@assets/icons/ether-icon.svg?react'
// import { ReactComponent as USDCIcon } from '@assets/icons/usdc-icon.svg'
import { MintType } from '@hooks/useMintTypeBased'

type NetworkSelectorProps = {
  mintType?: MintType.Eth
  setMintType: (mintType: MintType) => void
} & InputBaseProps

const NetworkOptions = {
  // [MintType.Usdc]: (
  //   <div className='flex gap-2 px-1 items-center font-semibold'>
  //     <USDCIcon className='h-5' /> USDC
  //   </div>
  // ),
  [MintType.Eth]: (
    <div className='flex gap-1  px-1  items-center font-semibold'>
      <ETHIcon className='h-5' /> ETH
    </div>
  )
}

const NetworkSelector = ({ mintType = MintType.Eth, setMintType, className, ...props }: NetworkSelectorProps) => {
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption()
  })

  return (
    <Combobox
      store={combobox}
      variant='unstyled'
      onOptionSubmit={(val: string) => {
        setMintType(val as MintType)
        combobox.closeDropdown()
      }}
    >
      <Combobox.Target>
        <InputBase
          component='button'
          className={clsx(className, 'w-full border-dark-700 border rounded-lg')}
          {...props}
          pointer
          variant='unstyled'
          rightSection={<Combobox.Chevron />}
          rightSectionPointerEvents='none'
          onClick={() => combobox.toggleDropdown()}
        >
          {NetworkOptions[mintType]}
        </InputBase>
      </Combobox.Target>

      <Combobox.Dropdown className='!bg-dark-900 !rounded-md !border-dark-700'>
        <Combobox.Options>
          {Object.entries(NetworkOptions).map(([key, value]) => (
            <Combobox.Option className='!px-0' value={key} key={key}>
              {value}
            </Combobox.Option>
          ))}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  )
}
export default NetworkSelector
